import DecreaseIcon from "assets/images/icons/decrease.svg";
import IncreaseIcon from "assets/images/icons/increase.svg";
import { useEffect, useState } from "react";

const WordpressOrder = ({ currentProduct, productGroup, setHostingProduct }) => {
  const [cloudPop, setCloudPop] = useState(0);

  const cloudPopHandle = (e) => {
    const btnName = e.target.alt;
    const limiter = productGroup.length;

    if (btnName.includes("increase") && cloudPop < limiter - 1) {
      setCloudPop(cloudPop + 1);
      setHostingProduct({ type: "INCREMENT_WP_PRODS" });
    }
    if (btnName.includes("decrease") && cloudPop !== 0) {
      setCloudPop(cloudPop - 1);
      setHostingProduct({ type: "DECREMENT_WP_PRODS" });
    }
    return;
  };

  useEffect(() => {
    if (productGroup.length !== 0) {
      const productIndex = productGroup.findIndex(
        (prod) => prod.pid === currentProduct.current.pid
      );
      setCloudPop(productIndex <= 0 ? 0 : productIndex);
    }
  }, [productGroup, currentProduct]);

  return (
    <div className="cloudpop-wrapper custom-product" id="sec-wordpress-hosting">
      <label htmlFor="cloudPop" className="form-label fw-bold mb-0">
        CloudPOP
      </label>
      <div className="d-flex align-items-center flex-wrap">
        <label htmlFor="increaseItem">Jumlah:</label>
        <div className="d-flex align-items-center ms-5 gap-2">
          <button className="btn btn-link p-0" onClick={cloudPopHandle}>
            <img src={DecreaseIcon} alt="decrease.svg" />
          </button>
          <div id="popTotal" className="mx-3">
            {cloudPop}
          </div>
          <button className="btn btn-link p-0" onClick={cloudPopHandle}>
            <img src={IncreaseIcon} alt="increase.svg" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WordpressOrder;
